export default __webpack_public_path__ + "static/media/dailyjam.349264fd.png";